import './style.scss'

import Message from 'element-ui/packages/message'

export default Message
